/**
 * EL .ESX SE EXIGE EN EL MOMENTO (Manuel 2026-10-05): "cuando se sube el estimado tiene que exigir
 * y de una vez abrir la pantalla en el medio para que suba el ESX; no lo deja hacer nada si no lo
 * sube… no debería darle un botón de 'no lo tengo'… en First Estimate, Review Estimate y Supplementing".
 *
 * Un solo modal para todo el app (`EsxRequiredHost`, montado en AppShell). Cualquier pantalla que
 * acaba de guardar un estimado NUESTRO llama `pedirEsx(claimId)`: el host le pregunta al servidor
 * (la misma regla `estadoEsx` que frena el avance) y, si falta, abre la ventana y no la cierra hasta
 * que el .ESX esté subido. La promesa se resuelve cuando ya está — o enseguida si no hacía falta.
 */
type Pedido = { claimId: string; listo: () => void };
let oyente: ((p: Pedido) => void) | null = null;
const enEspera: Pedido[] = [];

export function pedirEsx(claimId: string): Promise<void> {
  return new Promise<void>((listo) => {
    const p = { claimId: String(claimId), listo };
    if (oyente) oyente(p); else enEspera.push(p);
  });
}

/** Lo registra el host al montarse; recibe también los pedidos que llegaron antes. */
export function escucharPedidosDeEsx(fn: (p: Pedido) => void): () => void {
  oyente = fn;
  while (enEspera.length) fn(enEspera.shift()!);
  return () => { if (oyente === fn) oyente = null; };
}
export type PedidoDeEsx = Pedido;
